(() => {
  const page = document.body;
  if (!page) return;

  const isIndex = page.classList.contains('template-index');
  const sections = [...document.querySelectorAll('.watashi-section')];
  const links = [...document.querySelectorAll('.pet-brand-jump-links a')];
  const progress = document.querySelector('.pet-brand-scroll-progress');
  const heroBackdrop = document.querySelector('.watashi-hero__backdrop');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!sections.length && !isIndex && !document.querySelector('.watashi-story-section')) return;

  page.classList.add('pet-motion-ready');

  if (document.body.classList.contains('template-page') && sections.length) {
    sections.forEach((section) => section.classList.add('is-visible'));
  }

  links.forEach((link) => {
    const target = document.querySelector(link.getAttribute('href'));
    if (!target) link.hidden = true;
  });

  const markVisible = (el) => el.classList.add('is-visible');

  const animTargets = [
    ...sections,
    ...document.querySelectorAll(
      '.watashi-product-info, .watashi-legal-page, .product, .collection-hero, .watashi-story__gallery-item'
    ),
  ];

  if (reducedMotion || !('IntersectionObserver' in window)) {
    animTargets.forEach(markVisible);
  } else {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          markVisible(entry.target);
          observer.unobserve(entry.target);
        }
      }),
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 },
    );
    animTargets.forEach((el) => observer.observe(el));
  }

  if (!isIndex) return;

  let ticking = false;

  const updateScrollState = () => {
    const docH = document.documentElement.scrollHeight - window.innerHeight;
    const ratio = docH > 0 ? window.scrollY / docH : 0;
    if (progress) {
      progress.style.setProperty('--pet-scroll-progress', `${Math.max(0, Math.min(1, ratio)) * 100}%`);
    }

    if (heroBackdrop && !reducedMotion) {
      const rect = heroBackdrop.getBoundingClientRect();
      const shift = Math.max(-16, Math.min(16, (window.innerHeight * 0.5 - rect.top) * 0.05));
      heroBackdrop.style.setProperty('--pet-hero-shift', shift.toFixed(2));
    }

    const active = sections.reduce((cur, s) => {
      const d = Math.abs(s.getBoundingClientRect().top - window.innerHeight * 0.32);
      return !cur || d < cur.d ? { s, d } : cur;
    }, null);

    const id = active?.s.id;
    links.forEach((l) => l.classList.toggle('is-active', l.getAttribute('href') === `#${id}`));
    ticking = false;
  };

  const tick = () => {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollState);
      ticking = true;
    }
  };

  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick, { passive: true });
  updateScrollState();

  const slideshow = document.querySelector('[data-hero-slideshow]');
  if (slideshow) {
    const slides = [...slideshow.querySelectorAll('.watashi-hero__slide')];
    if (slides.length > 1 && !reducedMotion) {
      let idx = 0;
      window.setInterval(() => {
        slides[idx].classList.remove('is-active');
        idx = (idx + 1) % slides.length;
        slides[idx].classList.add('is-active');
      }, 5000);
    }
  }
})();
